export var selectLifeInsurance = function (state) { return state.lifeInsurance.InsuranceAgree; };
export var selectCreditRating = function (state) { return state.creditRating.CreditRatingAgree; };
